export default "__VITE_ASSET__$_NMAR1L__"